module.exports = __webpack_public_path__ + "img/pin_transport_purple.f7ff7c9a.svg";